<template>
<div>
  <div class="row">
    <div class="col-sm-24">
      <v-select
        v-model="contactReason"
        :label="$t('Grund der Anfrage')"
        :items="contactReasonItems"
        outlined
        filled
        attach
      ></v-select>
    </div>
  </div>

  <div class="row" v-if="contactReason === 'objekt-interesse'">
    <div class="col-sm-24">
      <v-text-field
        v-model="objektnummer"
        :label="$t('Objektnummer')"
        outlined
        filled
      ></v-text-field>
    </div>
  </div>

  <div class="row row-small" v-if="exclude.indexOf('person') == -1">
    <div class="col-md-12">
      <contact-select name="salutation" :label="$t('Anrede')" group="contact" :values="$t('Frau,Herr,Divers')" :placeholder="$t('Anrede')"></contact-select>
    </div>

    <div class="col-md-12">
      <contact-input name="title" :label="$t('Titel')" group="contact"></contact-input>
    </div>

    <div class="col-md-24">
      <div class="row row-small">
        <div class="col-md-12">
          <contact-input name="firstname" :label="$t('Vorname')" group="contact"></contact-input>
        </div>
        <div class="col-md-12">
          <contact-input name="lastname" :label="$t('Nachname')" group="contact"></contact-input>
        </div>
      </div>
    </div>
  </div>

  <div class="row row-small" v-if="exclude.indexOf('phone_email') == -1">
    <div class="col-12">
      <contact-input name="phone" :label="$t('Telefon')" group="contact"></contact-input>
    </div>
    <div class="col-12" v-if="exclude.indexOf('email') == -1">
      <contact-input name="email" :label="$t('E-Mail')" group="contact"></contact-input>
    </div>
  </div>

  <div class="row row-small">
    <div class="col-24 col-md-10">
      <contact-input name="street" :label="$t('Straße')" group="contact"></contact-input>
    </div>
    <div class="col-12 col-md-7">
      <contact-input name="zip" :label="$t('PLZ')" group="contact"></contact-input>
    </div>
    <div class="col-12 col-md-7">
      <contact-input name="city" :label="$t('Ort')" group="contact"></contact-input>
    </div>
  </div>

  <div class="row" v-if="exclude.indexOf('message') == -1">
    <div class="col-sm-24">
      <contact-input textarea :label="$t('Nachricht')" name="message" group="contact"></contact-input>
    </div>
  </div>

  <div class="row" v-if="exclude.indexOf('contactType') == -1">
    <div class="col-sm-24">
      <v-radio-group v-model="contactType" row :label="$t('Kontakt per:')" class="my-0 py-0" :hide-details="true">
        <v-radio hide-details :label="$t('E-Mail')" value="E-Mail" off-icon="fas fa-square" on-icon="fas fa-check-square"></v-radio>
        <v-radio hide-details :label="$t('Telefon')" value="Telefon" off-icon="fas fa-square" on-icon="fas fa-check-square"></v-radio>
      </v-radio-group>
    </div>
  </div>
</div>
</template>

<script>
import ContactInput from "./ContactInput.vue";
import ContactSelect from "./ContactSelect.vue";

export default {
  name: "ContactFields",

  components: {
    ContactInput,
    ContactSelect
  },

  props: {
    include: {
      type: Array,
      default: () => []
    },
    exclude: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      contactType: [],
      contactFinanzierungssprechstunde: false,
      contactReason: null,
      objektnummer: null
    };
  },

  computed: {
    fields() {
      if (!this.include) {
        return [];
      }

      return [...this.include];
    },

    contactReasonItems() {
      return [
        { text: this.$t('Allgemeine Anfrage'), value: 'allgemein' },
        { text: this.$t('Interesse an einem Objekt'), value: 'objekt-interesse' },
        { text: this.$t('Besichtigungstermin'), value: 'besichtigung' },
      ];
    }
  },

  mounted() {
    this.$root.contactForm.registerField(this);

    // Auto-Fill wenn auf Exposé-Seite geöffnet
    const cid = this.$root.contactForm.immoExposeCid;
    if (cid) {
      this.contactReason = 'objekt-interesse';
      this.objektnummer = cid;
    } else {
      // Auto-Fill via URL-Parameter (z.B. /kontakt/?objektnummer=XXX)
      const params = new URLSearchParams(window.location.search);
      const objNr = params.get('objektnummer');
      if (objNr) {
        this.contactReason = 'objekt-interesse';
        this.objektnummer = objNr;
      }
    }
  },

  beforeDestroy() {
    this.$root.contactForm.unregisterField(this);
  },

  methods: {
    mapValue() {
      this.$root.contactForm.contact.contactType = this.contactType;
      this.$root.contactForm.contact.contactReason = this.contactReason;
      this.$root.contactForm.contact.objektnummer = this.objektnummer;
    }
  }
};
</script>
